export enum ProfilePayType {
  CR = 'CR',
  TravelBank = 'TB',
}
